import type { PropTypes } from './DailyChart.type';
import type { ReactElement } from 'react';

import { Button } from '@rango-dev/whale';
import { FileChartColumnIncreasing } from 'lucide-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './DailyChart.module.css';
import { DailyChartModal } from './DailyChartModal';

const CHART_ICON_SIZE = 16;

export function DailyChart(props: PropTypes): ReactElement {
  const { t } = useTranslation();
  const { dailyData, loading } = props;
  const [showDailyChartModal, setShowDailyChartModal] = useState(false);
  const isDailyDataEmpty = !dailyData || !dailyData.length;
  const disabled = loading || isDailyDataEmpty;

  return (
    <>
      <Button
        id="profile-page-preview-daily-chart-btn"
        variant="outline"
        color="cyan"
        size="2"
        radius="full"
        disabled={disabled}
        onClick={() => setShowDailyChartModal(true)}
        className={styles.fullWidthButton}>
        <FileChartColumnIncreasing size={CHART_ICON_SIZE} />
        {t('Preview Daily chart')}
      </Button>
      {!isDailyDataEmpty && (
        <DailyChartModal
          dailyData={dailyData}
          open={showDailyChartModal}
          onClose={() => setShowDailyChartModal(false)}
        />
      )}
    </>
  );
}
